import Swal from "sweetalert2";
import { Apirequests } from "./ApiRequests";

export const handleRazorPayPayment = async (formData, orderId, setFormData, thankYouPageUrl, Razorpay, fetchOrders, invoiceId) => {
    var options = {
        "key": "rzp_test_xjk13ie9brLo0P",
        // "key": "rzp_live_vzB1GK1MVQTtsU",
         invoice_id: invoiceId,
        name: "Payment",
        description: "Payment Method",
        image: "https://silvamethod.com/img/logo/title-logo-removebg-preview.png",
        order_id: orderId,
        handler: async function (response) {
            if (response?.razorpay_payment_id) {
                const capturePayment = await
                    Apirequests("orders/capture-order", "POST", {
                        "paymentId": response?.razorpay_payment_id,
                    }, {});

                // fetch('https://silvamethod.in:5000/api/v1/orders/capture-order', {
                //     method: "POST",
                //     body: JSON.stringify({
                //         "paymentId": response?.razorpay_payment_id,
                //     }),
                //     headers: {
                //         "Content-Type": "application/json",
                //     }
                // });
                // console.log(capturePayment,'captureRes')

                // const captureRes = await capturePayment?.json();
                console.log(capturePayment, 'captureRes')

                if (capturePayment?.success) {
                    // toast.success("Payment Successful",{
                    //   position:"bottom-center"
                    // });
                    localStorage.setItem("silva_india_user_token", capturePayment?.token)
                    console.log("pay success")
                    if (thankYouPageUrl) {
                        window.location.href = `${thankYouPageUrl}`;
                    } else {
                        Swal.fire({
                            title: "Payment Successfull",
                            text: "Your last purchase was successfull. Thanks for being a part of Silva India Family. In case you face any issue please contact better@silvamethod.in",
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: "Okay",
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                                if (fetchOrders) {
                                    fetchOrders(capturePayment?.token)
                                }
                            }
                        });
                    }
                }
            }
        },
        "modal": {
            "ondismiss": async function () {
                // console.log(res,"failed response");
                const captRes = await
                    Apirequests("orders/capture-failed-payment", "POST", {
                        "order_id": orderId,
                    }, {});

                // fetch('https://silvamethod.in:5000/api/v1/orders/capture-failed-payment', {
                //     method: "POST",
                //     body: JSON.stringify({
                //         "order_id": order?.order_id,
                //     }),
                //     headers: {
                //         "Content-Type": "application/json",
                //     }
                // });
                // const captRes = await capt.json();
                console.log(captRes, 'failed res')

                if (captRes?.success) {
                    // toast.error("Payment Failed", {
                    //     position: "bottom-center"
                    // })
                    // console.log("payment failed")
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Payment Failed",
                        text: "Your last payment failed. Try again later",
                    });
                }
            }
        },
        prefill: {
            name: formData.name,
            email: formData.email,
            contact: formData.whatsapp_number,
            country: formData.country || "India",
            timeslot: formData.timeslot || "NA",
        },
        notes: {
            address: "The Silva Method India",
        },
        theme: {
            color: "#A500FF",
        },
    }


    const rzp1 = new Razorpay(options);


    rzp1.on("payment.failed", async function (response) {
        console.log(response.error.code);
        console.log(response.error.description);
        console.log(response.error.source);
        console.log(response.error.step);
        console.log(response.error.reason);
        console.log(response.error.metadata.order_id);
        console.log(response.error.metadata.payment_id);

        if (response?.error?.reason === "payment_failed") {
            const body = JSON.stringify({
                "paymentId": response?.error?.metadata?.payment_id,
            })
            const capturePayment = await Apirequests("orders/capture-order", "POST", body, {})
            // fetch('https://silvamethod.in:5000/api/v1/orders/capture-order', {
            //     method: "POST",
            //     body: JSON.stringify({
            //         "paymentId": response?.error?.metadata?.payment_id,
            //     }),
            //     headers: {
            //         "Content-Type": "application/json",
            //     }
            // });
            if (capturePayment?.success) {
                const modalElement = document.querySelector('.razorpay-container');
                if (modalElement) {
                    modalElement.style.display = 'none';
                }

            }
            window.location.href = '/payment-failure';
        }
    });

    // Swal.fire({
    //     position: "center",
    //     icon: "warning",
    //     title: "Caution",
    //     text: "After successful payment please wait until you go to the payment successful page. DO NOT close or refresh the page before that.",
    //     timer: 6000,
    //     timerProgressBar: true,
    //     didOpen: () => {
    //         Swal.showLoading();
    //     },
    // });
    Swal.fire({
        position: "center",
        icon: "info",
        title: "You're almost done!",
        text: "Once your payment is completed, please wait a few seconds while we securely confirm it. You'll be automatically redirected to the confirmation page.",
        timer: 6000,
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading();
        },
    });

    setTimeout(() => {
        rzp1.open();
    }, 6000)
}


export const handlePaymentNew = async (courseId, formData, purchaseType, headers, coupon, timeSlot, notes, currency) => {
    const reqBody = {
        product_id: courseId,
        // user_id: `${formData.name}-${formData.email}-${formData.whatsapp_number}-${formData.country || null}-${formData.timeslot || null}`,
        email: formData.email || "",
        name: formData.name || "",
        phone: formData.phone || "",
        country: formData.country || "",
        purchase_type: purchaseType || "",
        coupon,
        currency: currency || "INR",
        notes: { ...notes, timeSlot }
    }


    try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_URI}orders/create-order`,
            {
                method: "POST",
                body: JSON.stringify(reqBody),
                headers: {
                    "Content-Type": "application/json",
                    ...headers
                }
            }
        )
        const data = await res.json()
        // console.log(data);
        return data

    } catch (error) {
        console.log(error);
        return error
    }
}
